import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { SJProgressBarModule } from 'sj-progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProcessChartsRoutingModule } from './process-charts-routing.module';
import { ProcessChartsComponent } from './process-charts.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { ComparisonComponent } from './components/comparison/comparison.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RuleOutlierFilterPipe } from './pipes/rule-outlier-filter.pipe';
import { ParamFilterPipe } from './pipes/param-filter.pipe';
import { ExportViewComponent } from './components/export-view/export-view.component';
import { OutliersInfoCaptureComponent } from './components/outliers-info-capture/outliers-info-capture.component';
import { ManualOutliersRemovalComponent } from './components/manual-outliers-removal/manual-outliers-removal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CapabilityComponent } from './components/capability/capability.component';
import { ComparisonXrComponent } from './components/comparison-xr/comparison-xr.component';
import { SummaryComponent } from './components/summary/summary.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
    imports: [
        CommonModule,
        ProcessChartsRoutingModule,
        SharedModule,
        FormsModule,
        // SJProgressBarModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        DragDropModule
    ],
    schemas: [NO_ERRORS_SCHEMA],
    declarations: [
        ProcessChartsComponent,
        StatisticsComponent,
        ComparisonComponent,
        RuleOutlierFilterPipe,
        ParamFilterPipe,
        ExportViewComponent,
        OutliersInfoCaptureComponent,
        ManualOutliersRemovalComponent,
        CapabilityComponent,
        ComparisonXrComponent,
        SummaryComponent
    ],
    exports: [
        ComparisonComponent,
        StatisticsComponent,
        MatDialogModule,
        OutliersInfoCaptureComponent,
        ExportViewComponent
    ]
})
export class ProcessChartsModule { }
